import type { Location } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/asset/location/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

export const createFields: FormItem<Location>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Location Details',
    items: [allFields.name, allFields.tenantId],
  },
  {
    colCount: 1,
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 2,
        items: [allFields.level, allFields.parentId],
      },
      {
        colCount: 2,
        items: [allFields.lat, allFields.lng],
      },
      {
        colCount: 1,
        items: [allFields.notes],
      },
      {
        colCount: 1,
        items: [allFields.address],
      },
    ],
  },
];

export const updateFields: FormItem<Location>[] = [
  {
    colCount: 2,
    cssClass: 'tmm-section-no-background',
    caption: 'Location Details',
    items: [allFields.tenantId],
  },
  {
    colCount: 1,
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        colCount: 2,
        items: [allFields.name, allFields.inUseStatus],
      },
      {
        colCount: 2,
        items: [allFields.level, allFields.parentId],
      },
      {
        colCount: 3,
        items: [allFields.lat, allFields.lng, allFields.id],
      },
      {
        colCount: 1,
        items: [allFields.notes],
      },
      {
        colCount: 1,
        items: [allFields.address],
      },
    ],
  },
  getHistorySection(),
];
